import WhiteReceiptContent from "./WhiteReceiptContent";

export default WhiteReceiptContent;
